import { TCardTypeCard } from 'types/cardTypeMessage';
import { CardTypeMessagePicturesCarouselShell } from './CardTypeMessagePicturesCarouselShell';

type Props = {
  cards: TCardTypeCard[];
  activeIndex: number;
  onSelectCard: (index: number) => void;
};

export function CardTypeMessagePicturesCarouselPreview({
  cards,
  activeIndex,
  onSelectCard,
}: Props) {
  return (
    <CardTypeMessagePicturesCarouselShell
      cards={cards}
      variant="editor"
      activeIndex={activeIndex}
      onSelectCard={onSelectCard}
      className="max-w-[320px]"
    />
  );
}
